<template>
	<div @mouseover="pauseRemovingOfNotification" @mouseout="unpouseRemoving">
			<div
				:id="indexOfNotification"
				class="notification-container">

				<div class="content-wrapper">
					<img
					:class="[{'success' : type.toLowerCase() === NOTIFICATIONS.SUCCESS},
					{'error' : type.toLowerCase() === NOTIFICATIONS.ERROR},
					{'info' : type.toLowerCase() === NOTIFICATIONS.INFO},
					{'warning' : type.toLowerCase() === NOTIFICATIONS.WARNING}]"
					:src="require(`@/drc/assets/icons/${type.toLowerCase()}.svg`)"
					:alt="type">
					<span :class="[{'success' : type.toLowerCase() === NOTIFICATIONS.SUCCESS},
					{'error' : type.toLowerCase() === NOTIFICATIONS.ERROR},
					{'info' : type.toLowerCase() === NOTIFICATIONS.INFO},
					{'warning' : type.toLowerCase() === NOTIFICATIONS.WARNING},
					'text']"> {{ message }}</span>
				</div>
				<img
					:class="[{'success' : type.toLowerCase() === NOTIFICATIONS.SUCCESS},
					{'error' : type.toLowerCase() === NOTIFICATIONS.ERROR},
					{'info' : type.toLowerCase() === NOTIFICATIONS.INFO},
					{'warning' : type.toLowerCase() === NOTIFICATIONS.WARNING},
					'notification-close']"
					src="@/drc/assets/icons/close.svg"
					alt="close"
					@click="closeNotification($event)">
			</div>

	</div>
</template>

<script>
import {NOTIFICATION_TYPE} from "@/common/utils/constants"
export default {
	name: "SingleNotification",
	props: {
		type: {
			type: String,
			required: true
		},
		message: {
			type: String,
			required: true
		},
		indexOfNotification: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			isPaused: false,
			NOTIFICATIONS: NOTIFICATION_TYPE
		}
	},
	mounted() {
		setTimeout(() => {
			this.removeNotificationFromStore();
		}, 5000);
	},
	methods: {
		closeNotification(event) {
			this.$store.dispatch('removeNotification', event.target.parentNode.id);
		},
		removeNotificationFromStore() {
			if (this.isPaused === false) {
				this.$store.dispatch('removeNotification', this.indexOfNotification);
			} else {
				setTimeout(() => {
					this.removeNotificationFromStore();
				}, 3000);
			}
		},
		pauseRemovingOfNotification() {
			this.isPaused = true;
		},
		unpouseRemoving() {
			this.isPaused = false;
		}
	}
}
</script>
